import $ from 'jquery'
import 'magnific-popup'

function openInlineModal() {
  $('.js-open-modal').magnificPopup({
    type: 'inline',
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  })
}

export { openInlineModal }

function openGalleryModal() {
  $('.js-open-gallery').on('click', function trigger(event) {
    event.preventDefault()

    const gallery = $(this).attr('href')

    $(gallery)
      .magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
        },
      })
      .magnificPopup('open')
  })
}

export { openGalleryModal }

function openSliderGalleryModal() {
  $('.js-open-slider-gallery').each(function trigger() {
    // the containers for all your galleries
    $(this).magnificPopup({
      delegate: 'a', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled: true,
      },
    })
  })
}

export { openSliderGalleryModal }
